// extracted by mini-css-extract-plugin
module.exports = {"menuBlock":"Xe-z","title":"Ye-z","nav":"Ze-z","flexCell":"_e-z","facetLink":"af-z"};